/*
 * View for the dashboard learner button
 */

define([
  "marionette",
  "modules/dashboard/dashboardLearner/template/dashboardLearnerTemplate.html",
], function (Marionette, DashboardLearnerTemplate) {
  var DashboardLearnerView = {};

  DashboardLearnerView.dashboardLearnerView = Marionette.ItemView.extend({
    template: DashboardLearnerTemplate,
    modelEvents: {
      sync: "render",
    },
    triggers: {
      "click .btn": "click:button",
    },
  });

  return DashboardLearnerView;
});
